import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid
} from '@mui/material';
import { NetworkCheck } from '@mui/icons-material';

const NetworkingTab = ({ vmData }) => {
  return (
    <Box sx={{ py: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h6" mb={3}>
            Network Configuration
          </Typography>

          <Grid container spacing={4} mb={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" fontWeight="bold">
                Public IP
              </Typography>
              <Typography color="text.secondary">
                {vmData.publicIP}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" fontWeight="bold">
                Private IP
              </Typography>
              <Typography color="text.secondary">
                {vmData.privateIP}
              </Typography>
            </Grid>
          </Grid>

          <Button variant="contained" startIcon={<NetworkCheck />}>
            Configure Network Rules
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

NetworkingTab.propTypes = {
  vmData: PropTypes.shape({
    publicIP: PropTypes.string.isRequired,
    privateIP: PropTypes.string.isRequired,
  }).isRequired,
};

export default NetworkingTab;